import React, {useState} from 'react'
import UpdatePaymentMethod from './UpdatePaymentMethod';

const ViewPaymentMethod = () => {
  const [paypalButtons, setPaypalButtons] = useState(false);
  
  return (
    <div className='mt-4'>
        <h4 className='mb-3'>Manage Payment Method</h4>
        {/* Keep stuff below for the future just in case you add more payment options outside PayPal */}
        {/* <p className='m-0' style={{fontSize: "16px"}}>Payment Method</p>
        <p className='m-0'>Credit Card: foxmcdloud@starfox.com</p>
        <p className='m-0 mt-3' style={{color: "#FFCC19", cursor: "pointer"}} onClick={() => setPaypalButtons(true)}>Change</p>
        {paypalButtons && (
            <UpdatePaymentMethod />
        )} */}
      <p className="text-gray-400 text-sm" style={{maxWidth: "600px", fontSize: "15px"}}>
        Need to change your payment method? Manage it through your PayPal account.
        See <a href="/support" style={{color: "#FFCC19", fontWeight: "bold"}}>Help & Support</a> for instructions.
      </p>
    </div>
  )
}

export default ViewPaymentMethod